import { ethers } from 'ethers'

export class NftContract {
  constructor (
    public readonly address: string,
    public readonly abi: ethers.ContractInterface
  ) {
    this.address = ethers.utils.getAddress(address)
    this.abi = abi
  }
}
